// extracted by mini-css-extract-plugin
export var button = "c804c";
export var button__accept = "_4b9fe";
export var button__danger = "be5bb";
export var controls = "a4acf";
export var message = "e3c84";
export var title = "_03af0";